module.exports = __webpack_public_path__ + "static/media/teammatch2.d31253de.svg";